import styled from "styled-components";

import { CSS_VARIABLES } from "enums/cssVariables";

import { ValidateButtonStyleProps } from "../types";
import {
    VOTEBOX_ACTION_SECTION_MARGIN_BOTTOM,
    VOTEBOX_BORDER_WIDTH,
    VOTEBOX_FONT_SIZE_BODY,
    VOTEBOX_FONT_WEIGHT_SEMIBOLD,
    VOTEBOX_OPTION_MIN_HEIGHT,
    VOTEBOX_OPTION_RADIUS,
    VOTEBOX_WHITE,
} from "../voteboxTokens";
import { BaseOptionButton } from "./BaseOptionButton";

export const StyledButton = styled(BaseOptionButton)<ValidateButtonStyleProps>`
    min-height: ${VOTEBOX_OPTION_MIN_HEIGHT};
    background: ${(props) =>
        props.$isOutlined
            ? VOTEBOX_WHITE
            : `var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR})`};
    color: ${(props) =>
        props.$isOutlined
            ? `var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR})`
            : `var(${CSS_VARIABLES.PRIMARY_BUTTON_TEXT_COLOR})`};
    border: ${VOTEBOX_BORDER_WIDTH} solid
        var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
    margin-bottom: ${VOTEBOX_ACTION_SECTION_MARGIN_BOTTOM};
    border-radius: ${VOTEBOX_OPTION_RADIUS};
    font-size: ${VOTEBOX_FONT_SIZE_BODY};
    font-weight: ${VOTEBOX_FONT_WEIGHT_SEMIBOLD};
    &[aria-disabled="true"] {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;
